// Meta
export const name = "gvMarkdown";
